import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="counter"
export default class extends Controller {
  static values = {
    target: Number,
    duration: { type: Number, default: 2000 },
    suffix: { type: String, default: "" },
    prefix: { type: String, default: "" }
  }

  connect() {
    this.hasAnimated = false
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animate()
            this.hasAnimated = true
            this.observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.5
      }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  animate() {
    const start = 0
    const end = this.targetValue
    const duration = this.durationValue
    const startTime = performance.now()

    const updateCounter = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)
      
      // Easing function for smooth animation
      const easeOutQuad = progress * (2 - progress)
      const current = Math.floor(start + (end - start) * easeOutQuad)
      
      this.element.textContent = this.prefixValue + current + this.suffixValue
      
      if (progress < 1) {
        requestAnimationFrame(updateCounter)
      } else {
        this.element.textContent = this.prefixValue + end + this.suffixValue
      }
    }

    requestAnimationFrame(updateCounter)
  }
}
